import React from 'react';

interface MegacomScreen3DIconProps {
  size?: number;
  color?: string;
}

export const MegacomScreen3DIcon = ({ size = 48, color = '#BC1A6C' }: MegacomScreen3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 30);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="10" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Pole */}
      <rect x="29" y="40" width="3" height="16" fill={darkerColor} rx="1" />
      <rect x="30" y="40" width="3" height="16" fill={color} rx="1" />
      {/* Pole base */}
      <rect x="24" y="54" width="16" height="3" rx="1.5" fill={darkerColor} />
      <rect x="24" y="52" width="16" height="3" rx="1.5" fill={color} />
      {/* Vertical/portrait screen - taller than wide */}
      <rect x="18" y="4" width="24" height="36" rx="2" fill={color} />
      <path d="M42 4 L46 2 L46 38 L42 40 Z" fill={darkerColor} />
      <path d="M18 4 L22 2 L46 2 L42 4 Z" fill={lighterColor} />
      {/* Screen inner */}
      <rect x="21" y="7" width="18" height="30" rx="1" fill="white" opacity="0.25" />
      {/* Ad content - vertical bars */}
      <rect x="23" y="10" width="4" height="20" rx="1" fill="white" opacity="0.15" />
      <rect x="29" y="14" width="4" height="16" rx="1" fill="white" opacity="0.12" />
      <rect x="35" y="10" width="2" height="20" rx="1" fill="white" opacity="0.1" />
      {/* Shine */}
      <rect x="18" y="4" width="24" height="4" rx="2" fill="white" opacity="0.15" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
